import React, { useEffect, useState } from 'react';

import step01 from '../../Assets/ResearchFund/Process/01.png';
import step02 from '../../Assets/ResearchFund/Process/02.png';
import step03 from '../../Assets/ResearchFund/Process/03.png';
import step04 from '../../Assets/ResearchFund/Process/04.png';
import step05 from '../../Assets/ResearchFund/Process/05.png';
import step06 from '../../Assets/ResearchFund/Process/06.png';
import step07 from '../../Assets/ResearchFund/Process/07.png';
import step08 from '../../Assets/ResearchFund/Process/08.png';
import step09 from '../../Assets/ResearchFund/Process/09.png';
import step10 from '../../Assets/ResearchFund/Process/10.png';

const processSteps = [step01, step02, step03, step04, step05, step06, step07, step08, step09, step10];

const ResearchFundProcess = () => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(
      () => setActiveStep((current) => (current + 1) % processSteps.length),
      2000,
    );
    return () => window.clearInterval(timer);
  }, []);

  return (
    <section className="research-fund-process" aria-labelledby="research-fund-process-title">
    <div className="research-fund-process-header">
      <p className="section-eyebrow">FROM PROPOSAL · TO FUNDED RESEARCH</p>
      <h2 id="research-fund-process-title">RF Process</h2>
      <div className="research-fund-title-line" aria-hidden="true" />
      <p>
        The NCGSA Research Fund Program follows a structured and transparent process that begins
        with a formal call for proposals, inviting faculty and researchers from HEIs and R&amp;D
        organizations to submit joint academia-industry projects in key domains such as Remote
        Sensing, Small Satellite Technology, PNT, Space Applications, and Outreach. Proposals must
        demonstrate innovation, feasibility, societal impact, and potential for commercialization.
        Following the announcement, proposals are submitted and screened against predefined
        selection criteria, including scientific merit, implementation plan, team expertise, and
        alignment with national priorities. A multi-level review process involving expert
        committees, peer reviewers, and industry evaluators culminates in a final pitching round.
        After careful evaluation, <strong>13 projects were selected</strong> for funding, each
        receiving up to PKR 15 million over two years, followed by contract signing and
        milestone-based fund disbursement.
      </p>
    </div>
    <div className="research-fund-process-slider">
      <article className="research-fund-process-step">
        <div className="research-fund-step-marker">
          <span>STEP</span>
          <strong>{String(activeStep + 1).padStart(2, '0')}</strong>
        </div>
        <figure>
          <img
            key={processSteps[activeStep]}
            src={processSteps[activeStep]}
            alt={`NCGSA Research Fund process step ${activeStep + 1}`}
          />
        </figure>
      </article>
      <div className="research-fund-process-controls">
        <button type="button" onClick={() => setActiveStep((activeStep - 1 + processSteps.length) % processSteps.length)} aria-label="Previous Research Fund process step">←</button>
        <div className="research-fund-process-dots" aria-label={`Step ${activeStep + 1} of ${processSteps.length}`}>
          {processSteps.map((step, index) => (
            <button key={step} type="button" className={index === activeStep ? 'active' : ''} onClick={() => setActiveStep(index)} aria-label={`Show process step ${index + 1}`} />
          ))}
        </div>
        <button type="button" onClick={() => setActiveStep((activeStep + 1) % processSteps.length)} aria-label="Next Research Fund process step">→</button>
      </div>
    </div>
    </section>
  );
};

export default ResearchFundProcess;
